import { FC } from 'react';
import { baseUrl } from 'src/api/Api';
import { ItemDocument } from 'src/types/itemDocument';

declare interface IProps {
  document: ItemDocument;
}

const ItemDocumentLink: FC<React.PropsWithChildren<IProps>> = ({ document }) => {
  return (
    <a className="item-detail-buyer" href={`${baseUrl}${document.url}`} target="_blank">
      {document.name}
    </a>
  );
};

export default ItemDocumentLink;
